import axios from "axios";
import { encryptText } from "util/security";
import { executeAnonymous } from "./api";
import cordovaAdapter from "./axiosCordovaAdapter";

const OIDC_WEB_CLIENT_ID = "web-client";

let oauthAxios;
if (window.isMobileApp() && window.API_URL.startsWith("https://")) {
    oauthAxios = axios.create({
        validateStatus(status) {
            return status >= 200 && status < 500;
        },
        adapter: cordovaAdapter,
    });
} else {
    oauthAxios = axios.create({
        validateStatus(status) {
            return status >= 200 && status < 500;
        },
    });
}

oauthAxios.defaults.baseURL = window.OAUTH_URL;
oauthAxios.defaults.headers.common.Accept = "application/json";

oauthAxios.interceptors.response.use(
    (response) => {
        if (response.status === 204) {
            return response;
        }

        // cubre el caso de un download de un archivo
        if (response.status === 200 && response.request.responseType === "blob") {
            return response;
        }
        if (response.status === 200) {
            response.type = "I";
        } else {
            response.type = "W";
        }
        return response;
    },
    (error) => {
        // se agrega el atributo para saber que es un error de saga
        // eslint-disable-next-line
        error.httpError = true;

        throw error;
    },
);

function mapOidcBffResponse(apiResponse) {
    if (apiResponse.type === "I") {
        return {
            type: "I",
            status: 200,
            data: apiResponse.data.data || {},
        };
    }

    return {
        type: "W",
        status: 200,
        data: {
            error_description: apiResponse.data.code || "invalid_grant",
        },
    };
}

export function executePasswordGrant(username, password) {
    // Switch: Si OAUTH_OIDC_URL está definida → usa OIDC (Keycloak), sino → legacy
    const useOIDC = window.OAUTH_OIDC_URL && window.OAUTH_OIDC_URL !== "";

    if (useOIDC) {
        return executeAnonymous("/oauth.oidc.passwordToken", {
            username,
            password,
        }).then(mapOidcBffResponse);
    }

    const body = encode({
        grant_type: "password",
        username: encryptText(username),
        password: encryptText(password),
        channel: "frontend",
    });

    return oauthAxios.post(`${window.OAUTH_URL}/token`, body, {
        headers: {
            Authorization: `Basic ${btoa(`${OIDC_WEB_CLIENT_ID}:web-secret`)}`,
            "Content-Type": "application/x-www-form-urlencoded",
            channel: "frontend",
        },
    });
}

export function executeImplicit(clientId, redirectUri, thirdPartyToken, email, password) {
    return oauthAxios.post(
        `/authorize?response_type=token&client_id=${clientId}&custom_token=${thirdPartyToken}
        &redirect_uri=${redirectUri}`,
        null,
        {
            headers: {
                Authorization: `Basic ${btoa(`${encryptText(email)}:${encryptText(password)}`)}`,
                "Content-Type": "application/x-www-form-urlencoded",
                channel: "assistant",
            },
        },
    );
}

function encode(json) {
    let ret = "";
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of Object.entries(json)) {
        ret += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`;
    }
    return ret.slice(0, -1);
}
